import { injectGlobal } from "@emotion/css";
import { createRoot } from "react-dom/client";
import { normalizePathname } from "shared-resources";
import { App } from "./App";

normalizePathname();

injectGlobal`
    * {
        box-sizing: border-box;
    }

    body {
        font-family: Graphik, Avenir Next, Helvetica Neue, Helvetica, Arial, sans-serif !important;
        margin: 0;
    }

    a {
        text-decoration: none;
    }

`;
const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(<App />);
